import React, { useEffect, useState } from 'react';
import { bookingApi, formatApiError } from '../services/api';
import { bookingEditPayload } from '../lib/bookingEditPayload';
import { euro } from '../lib/bookingChecks';

export default function BookingChangePreview({ booking, form, onPreview }) {
  const key = JSON.stringify(bookingEditPayload(form));
  const changed = form.end_date !== booking.end_date?.slice(0, 10);
  const [state, setState] = useState({ key: '', data: null, error: '' });
  useEffect(() => {
    onPreview(null);
    if (!changed) return;
    let cancelled = false;
    const timer = setTimeout(() => {
      bookingApi.previewChange(booking.id, JSON.parse(key)).then(response => {
        if (cancelled) return;
        setState({ key, data: response.data, error: '' });
        onPreview({ key, data: response.data });
      }).catch(error => {
        if (!cancelled) setState({ key, data: null, error: formatApiError(error) });
      });
    }, 350);
    return () => { cancelled = true; clearTimeout(timer); };
  }, [booking.id, key, changed, onPreview]);
  if (!changed) return null;
  const current = state.key === key;
  const preview = current ? state.data : null;
  return <section className="p-3 border border-blue-200 bg-blue-50 rounded-sm text-sm space-y-2" aria-live="polite" data-testid="booking-change-preview">
    <h3 className="font-semibold">Mietzeit und Kosten vor dem Speichern</h3>
    <p>Bisheriges Mietende: {booking.end_date?.slice(0, 10)} · Neues Mietende: {form.end_date}</p>
    {current && state.error ? <p role="alert">{state.error} Die Änderung kann erst nach erfolgreicher Kostenprüfung gespeichert werden.</p> : !preview ? <p>Kosten werden berechnet …</p> : <>
      {preview.additional_days > 0 && <p>Zusätzliche Miettage: <strong>{preview.additional_days}</strong></p>}
      {preview.extension ? <>
        <p>Nachberechnung: {preview.extension.days} Tage × {euro(preview.extension.daily_rate)} ≈ <strong>{euro(preview.extension.total)}</strong> brutto.</p>
        <p>{preview.extension.already_invoiced ? 'Für diesen Zeitraum besteht bereits eine Verlängerungsrechnung.' : 'Beim Speichern wird eine separate Verlängerungsrechnung erstellt.'} Bereits ausgestellte Rechnungen bleiben erhalten.</p>
      </> : preview.shortening ? <p>Verkürzung: Offene Verlängerungsrechnungen für den entfallenden Zeitraum werden storniert. Bereits bezahlte Verlängerungsrechnungen müssen zuerst geklärt werden.</p> : <p>Es gibt keine abrechenbare ursprüngliche Mietrechnung. Die Buchung erhält den neuen Preis; es entsteht keine separate Verlängerungsrechnung.</p>}
      <p>Buchungspreis bisher: {euro(preview.previous_total)} · Neu: <strong>{euro(preview.price_info.total_price)}</strong> brutto.</p>
      {preview.extension && <p className="text-xs">Der Buchungspreis ist die aktuelle Tarifberechnung. Die separate Nachberechnung richtet sich nach der ursprünglichen Mietrechnung.</p>}
    </>}
  </section>;
}
